// extracted by mini-css-extract-plugin
export default {"content":"Gr0wnHNDsUit6l63aYKv"};